<template>
  <div class="px-8 pt-3 pb-10 md:px-24">
    <settings-header
      active-tab="sheets"
      :entity-id="entity.id"
    />
    <div
      v-if="sheetConnected"
      class="flex mt-10"
    >
      <h1
        class="text-xl text-left text-sc-gray-dark"
        ref="google-sheets-title"
      >
        {{ $t('message.settings.sheetsTab.connectedGoogleSheet') }}
      </h1>
    </div>
    <b-loading
      :is-full-page="false"
      v-model="loading"
    />
    <div class="mt-10">
      <div
        v-if="sheetConnected"
        class="flex flex-col items-center mx-auto w-88"
      >
        <img
          :src="require('@assets/images/sheets.svg')"
        >
        <a
          ref="google-sheets-url"
          class="w-full my-5 text-lg text-center underline truncate border-none appearance-none focus:outline-none text-link hover:text-sc-blue-light"
          :href="sheetUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ sheetUrl }}
        </a>
        <div class="flex justify-between w-full">
          <button
            class="flex-1 px-4 py-1 mr-1 text-xs text-white rounded bg-sc-blue hover:bg-sc-blue-light"
            @click="copyToClipboard(sheetUrl)"
            ref="google-sheets-copy-link-button"
          >
            {{ $t('message.settings.sheetsTab.copyLinkButton') }}
          </button>
          <button
            class="flex-1 px-4 py-1 ml-1 text-xs text-white rounded bg-sc-red"
            @click="disconnectSheet()"
            ref="google-sheets-remove-button"
          >
            {{ $t('message.settings.sheetsTab.removeButton') }}
          </button>
        </div>
      </div>
      <sheet-stepper
        v-if="!sheetConnected"
        @connect="connectSheet"
      />
      <div
        v-if="error"
        class="mt-1 mb-10 ml-10 text-sm text-sc-red"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import SheetsApi from '../../api/sheets';
import SettingsHeader from '../settings-header.vue';
import SheetStepper from './sheet-stepper.vue';

export default {
  data() {
    return {
      loading: false,
      sheetUrl: this.sheet ? this.sheet.url : null,
      sheetConnected: this.sheet ? this.sheet.connected : null,
      error: null,
      message: '',
    };
  },
  components: {
    SettingsHeader,
    SheetStepper,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
    sheet: {
      type: Object,
      required: false,
      default: null,
    },
    email: {
      type: String,
      required: true,
    },
  },
  methods: {
    async connectSheet(url) {
      this.loading = true;

      SheetsApi.create(this.entity.id, { newSheetUrl: url }).then((response) => {
        this.sheetConnected = response.sheet.connected;
        if (this.sheetConnected) {
          this.sheetUrl = response.sheet.url;
          this.$buefy.toast.open({
            message: this.$t('message.settings.sheetsTab.steps.connectionSuccess'),
            position: 'is-bottom',
          });
        } else throw Error;
      }).catch(() =>
        this.$buefy.toast.open({
          message: this.$t('message.settings.sheetsTab.steps.connectionError'),
          position: 'is-bottom',
          type: 'is-danger',
        }));
      this.loading = false;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text)
        .then(this.$buefy.toast.open({
          message: this.$t('message.settings.sheetsTab.copyLinkSuccess'),
          position: 'is-bottom',
        }));
    },
    async disconnectSheet() {
      this.loading = true;
      SheetsApi.delete(this.entity.id, this.sheet.id).then(() => {
        this.sheetUrl = null;
        this.sheetConnected = false;
        this.$buefy.toast.open({
          message: this.$t('message.settings.sheetsTab.disconectionSuccess'),
          position: 'is-bottom',
        });
      }).catch(() =>
        this.$buefy.toast.open({
          message: this.$t('message.settings.sheetsTab.disconectionError'),
          position: 'is-bottom',
          type: 'is-success',
        }));
      this.loading = false;
    },
  },
};
</script>
